import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Card, Alert, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./InterestedCandidatePage.css";
import { useDispatch, useSelector } from "react-redux";
import { createintrestedcandidate } from "../actions/IntrestedCandidateAction";
import { getsubsection } from "../actions/subsectionAction";
// Ensure these paths are correct for your project structure
import registrationlogo from "../pages/assets/registrationlogo.png";
import Sidelog from "../pages/assets/sidelogo.png";

const CandidateFormOrange = () => {
    const dispatch = useDispatch();

    // Get subsection data from Redux store
    const subsectionState = useSelector(state => state.subsection);
    const { subsection = [] } = subsectionState || {};

    // Load subsection data when component mounts
    useEffect(() => {
        dispatch(getsubsection());
    }, [dispatch]);

    // --- REDUX STATE FOR CANDIDATE ---
    const intrestedcandidateState = useSelector(state => state.intrestedcandidate);
    const { createintrestedcandidate: createSuccess, error: createError } = intrestedcandidateState || {};

    // --- LOCAL STATE ---
    const [showDuplicateModal, setShowDuplicateModal] = useState(false); // <--- NEW STATE FOR DUPLICATE POPUP
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [photoPreview, setPhotoPreview] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const [formData, setFormData] = useState({
        otherDocumentPdf: null,
        seatCode: "",
        membershipNo: "",
        date: new Date().toISOString().split('T')[0],
        // Personal Information
        wardNo: "",
        partNo: "",
        voterSrNo: "",
        fullName: "",
        address: "",
        email: "",
        mobile: "",
        caste: "",
        casteFile: null,
        dob: "",
        age: "",
        education: "",
        occupation: "",
        income: "",
        yearsInParty: "",
        partyPost: "",
        govPost: "",
        prevPost: "",
        socialWork: "",
        privateInfo: "",

        // Ward Information
        resA: "", resB: "", resC: "", resD: "",
        statusA: "", statusB: "", statusC: "",
        voterCount: "", population: "", boothParts: "",
        specialInfo: "", prevVotes: "",

        // Declaration
        decName: "",
        place: "",
        signature: null,
        photo: null
    });

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;

        if (type === "file") {
            let file = files[0];
            if (!file) return;

            if (/\s/.test(file.name)) {
                const newFileName = file.name.replace(/\s+/g, "_");
                file = new File([file], newFileName, { type: file.type });
                console.log(`Filename contained spaces. Renamed to: ${newFileName}`);
            }

            if (name === "casteFile" || name === "otherDocumentPdf") {
                const fileName = file.name;
                const isPdf = fileName.toLowerCase().endsWith(".pdf");
                const isImage = file.type.startsWith("image/");

                if (!isPdf && !isImage) {
                    alert("फक्त PDF किंवा इमेज फाइल मान्य आहेत (Only PDF or Image allowed).");
                    e.target.value = "";
                    return;
                }
            }

            if (name === "photo" && file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPhotoPreview(reader.result);
                };
                reader.readAsDataURL(file);
            }

            setFormData((prev) => ({
                ...prev,
                [name]: file,
            }));
        } else {
            if (name === "dob") {
                const dobDate = new Date(value);
                const today = new Date();
                let age = today.getFullYear() - dobDate.getFullYear();
                const m = today.getMonth() - dobDate.getMonth();
                if (m < 0 || (m === 0 && today.getDate() < dobDate.getDate())) {
                    age--;
                }
                const calculatedAge = value && !isNaN(age) ? age.toString() : "";

                setFormData((prev) => ({
                    ...prev,
                    dob: value,
                    age: calculatedAge,
                }));
            } else {
                setFormData((prev) => ({
                    ...prev,
                    [name]: value,
                }));
            }
        }
    };

    const handleClose = () => {
        setFormData({
            otherDocumentPdf: null,
            seatCode: "",
            membershipNo: "",
            date: new Date().toISOString().split('T')[0],
            wardNo: "",
            partNo: "",
            voterSrNo: "",
            fullName: "",
            address: "",
            email: "",
            mobile: "",
            caste: "",
            casteFile: null,
            dob: "",
            age: "",
            education: "",
            occupation: "",
            income: "",
            yearsInParty: "",
            partyPost: "",
            govPost: "",
            prevPost: "",
            socialWork: "",
            privateInfo: "",
            resA: "", resB: "", resC: "", resD: "",
            statusA: "", statusB: "", statusC: "",
            voterCount: "", population: "", boothParts: "",
            specialInfo: "", prevVotes: "",
            decName: "",
            place: "",
            signature: null,
            photo: null
        });
        setPhotoPreview(null);
        setShowModal(false);
    };

    const validateForm = () => {
        const requiredFields = [
            "wardNo", "seatCode", "partNo", "voterSrNo", "membershipNo",
            "fullName", "email", "address", "mobile",
            "dob", "age", "education", "occupation", "income",
            "yearsInParty", "partyPost", "govPost", "prevPost",
            "socialWork", "privateInfo",
            "resA", "resB", "resC", "resD",
            "statusA", "statusB", "statusC",
            "voterCount", "population", "boothParts",
            "specialInfo", "prevVotes", "place",
        ];

        const fieldLabels = {
            wardNo: "वार्ड क्रमांक",
            seatCode: "सीट कोड",
            partNo: "भाग क्रमांक",
            voterSrNo: "मतदार क्रमांक",
            membershipNo: "सदस्य क्रमांक",
            fullName: "पूर्ण नाव",
            email: "ईमेल",
            address: "पत्ता",
            mobile: "मोबाइल",
            dob: "जन्मतारीख",
            age: "वय",
            education: "शिक्षण",
            occupation: "व्यवसाय",
            income: "उत्पन्न",
            yearsInParty: "पक्षातील वर्षे",
            partyPost: "पक्ष पद",
            govPost: "शासकीय पद",
            prevPost: "मागील पद",
            socialWork: "सामाजिक कार्य",
            privateInfo: "खासगी माहिती",
            resA: "A क्षेत्र",
            resB: "B क्षेत्र",
            resC: "C क्षेत्र",
            resD: "D क्षेत्र",
            statusA: "A स्थिती",
            statusB: "B स्थिती",
            statusC: "C स्थिती",
            voterCount: "एकूण मतदार",
            population: "लोकसंख्या",
            boothParts: "बूथ भाग",
            specialInfo: "विशेष माहिती",
            prevVotes: "मागील मतसंख्या",
            place: "ठिकाण",
        };

        const missing = [];

        for (let field of requiredFields) {
            if (!formData[field] || formData[field].toString().trim() === "") {
                missing.push(fieldLabels[field] || field);
            }
        }
        const mobileRegex = /^[0-9]{10}$/;
        if (formData.mobile && !mobileRegex.test(formData.mobile)) {
            alert("मोबाईल नंबर 10 अंकी असणे आवश्यक आहे (Mobile number must be exactly 10 digits).");
            return false;
        }

        if (missing.length > 0) {
            alert("कृपया खालील फील्ड भरा:\n\n" + missing.join("\n"));
            setShowErrorModal(true);
            return false;
        }
        return true;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const selectedWardData = subsection.find(
            (item) => item.name === formData.wardNo
        );
        const submitData = new FormData();

        submitData.append("seatNo", formData.seatCode || "1");
        submitData.append("membershipNo", formData.membershipNo || "");
        submitData.append("date", formData.date || "");
        submitData.append("fullName", formData.fullName || "");
        submitData.append("email", formData.email || "");
        submitData.append("age", formData.age || "");
        submitData.append("fullAddress", formData.address || "");
        submitData.append("caste", formData.caste || "");
        submitData.append("telephone", formData.mobile || "");
        submitData.append("mobile", formData.mobile || "");
        submitData.append("voterListNo", formData.voterSrNo || "");
        submitData.append("partNo", formData.partNo || "");
        submitData.append("wardNo", formData.wardNo || "");
        submitData.append("education", formData.education || "");
        submitData.append("occupation", formData.occupation || "");
        submitData.append("annualIncome", formData.income || "");
        submitData.append("yearsInParty", formData.yearsInParty || "");
        submitData.append("partyPosition", formData.partyPost || "");
        submitData.append("govtPosition", formData.govPost || "");
        submitData.append("previousPosition", formData.prevPost || "");
        submitData.append("socialWork", formData.socialWork || "");
        submitData.append("spendingCapacity", formData.privateInfo || "");
        submitData.append("dateOfBirth", formData.dob || "");

        submitData.append("A", formData.resA || "");
        submitData.append("B", formData.resB || "");
        submitData.append("C", formData.resC || "");
        submitData.append("D", formData.resD || "");
        submitData.append("A_party", formData.statusA || "");
        submitData.append("B_party", formData.statusB || "");
        submitData.append("C_party", formData.statusC || "");
        submitData.append("total_votars", formData.voterCount || "");
        submitData.append("ward_popul", formData.population || "");
        submitData.append("all_list_part_numbers", formData.boothParts || "");
        submitData.append("special_info", formData.specialInfo || "");
        submitData.append("votes_receive_previously", formData.prevVotes || "");
        submitData.append("place", formData.place || "");

        submitData.append("documentPdf", formData.casteFile || "");
        submitData.append("image", formData.photo || "");
        submitData.append("otherDocumentPdf", formData.otherDocumentPdf || "");

        submitData.append("subsectionId", selectedWardData.id);
        submitData.append("electionTypeId", selectedWardData.electionTypeId || "1");

        dispatch(createintrestedcandidate(submitData));
        setSubmitted(true);
        setTimeout(() => {
            setSubmitted(false);
        }, 5000);
    };

    // --- SUCCESS EFFECT ---
    useEffect(() => {
        if (createSuccess) {
            setShowModal(true);
            setSubmitted(true);
        }
    }, [createSuccess]);

    // --- ERROR EFFECT (DUPLICATE) ---
    useEffect(() => {
        if (createError) {
            // Check if status is 409 OR message contains "Duplicate"
            // Adjust property names based on exactly what your backend returns (e.g., createError.message or createError.error)
            if (
                createError.status === 409 ||
                (createError.message && createError.message.toLowerCase().includes("duplicate")) ||
                (typeof createError === 'string' && createError.toLowerCase().includes("duplicate"))
            ) {
                setShowDuplicateModal(true);
            } else {
                // If it's a different error, you might want to show an alert or just log it
                alert("Error: " + (createError.message || "काहीतरी चूक झाली आहे."));
            }
        }
    }, [createError]);

    return (
        <Container className="paper-container py-4">

            {/* --- 1. Validation Error Modal --- */}
            <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)} centered>
                <Modal.Header closeButton className="bg-danger text-white">
                    <Modal.Title>Alert</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center p-4">
                    <h5 className="text-danger">All fields are required!</h5>
                    <p>कृपया अर्जातील सर्व रकाने भरा आणि सर्व फाईल्स (फोटो, जात प्रमाणपत्र, सही) अपलोड करा.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => setShowErrorModal(false)}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* --- 2. Success Modal --- */}
            <Modal show={showModal} onHide={handleClose} centered backdrop="static">
                <Modal.Header closeButton className="bg-success text-white">
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center p-4">
                    <h4 className="text-success">Candidate Saved Successfully!</h4>
                    <p>उमेदवारी अर्ज यशस्वीरित्या सबमिट झाला आहे.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={handleClose}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* --- 3. DUPLICATE ERROR MODAL (NEW) --- */}
            <Modal show={showDuplicateModal} onHide={() => setShowDuplicateModal(false)} centered>
                <Modal.Header closeButton className="bg-danger">
                    <Modal.Title>Already Exists</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center p-4">
                    <h5 className="text-danger">Duplicate Entry Found!</h5>

                    <p className="small text-muted"> Your mobile number is already registered Please use another number or contact support.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => setShowDuplicateModal(false)}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* {submitted && (
                <Alert variant="success" className="text-center shadow mb-4">
                    <strong>यशस्वी!</strong> अर्ज सबमिट केला आहे.
                </Alert>
            )} */}
            {/* ======================================================= */}
            {/* START: RUNNING NOTICE BAR */}
            {/* ======================================================= */}
            <div className="running-notice-container">
                <div className="running-notice-text">
                    <span className="running-notice-content">
                        {/* You can use a Bootstrap Icon here if available, or just the symbol */}
                        <i className="bi bi-exclamation-triangle-fill notice-icon"></i>
                        ⚠️
                        &nbsp;
                        <strong>महत्वाची सूचना:</strong>
                        {/* तांत्रिक अडचणी टाळण्यासाठी आणि अर्ज सहज सबमिट करण्यासाठी, कृपया अर्जातील माहिती फक्त */}
                        तांत्रिक अडचणी टाळण्यासाठी कृपया अर्जातील सर्व माहिती
                        <span style={{ color: 'black', textDecoration: 'underline' }}>फक्त इंग्रजी (English) </span>
                        भाषेतच भरावी.
                        &nbsp; | &nbsp;
                        <strong>Important Notice:</strong>
                        To avoid technical conflicts please fill the form in
                        <span style={{ color: 'black', textDecoration: 'underline' }}> English Language </span>
                        only.
                    </span>
                </div>
            </div>
            {/* END: RUNNING NOTICE BAR */}
            {/* ======================================================= */}

            <div className="paper-sheet shadow-lg p-2">
                <div style={{ border: "2px solid black" }}>
                    {/* --- HEADER BANNER --- */}
                    <div className="header-banner">
                        <img
                            src={registrationlogo}
                            alt="Shivsena Header"
                            style={{ width: "100%", height: "auto", display: "block" }}
                        />
                    </div>

                    <div className="p-4 content-body">
                        <Form onSubmit={handleSubmit}>

                            {/* --- TOP INFO (Date, App No, Photo) --- */}
                            <div className="d-flex justify-content-between align-items-start mb-3">
                                <div className="w-75">
                                    <div className="d-flex align-items-center mb-2">
                                        <Form.Label className="fw-bold me-2 mb-0">दिनांक :</Form.Label>
                                        <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} className="line-input w-25" />

                                        <Form.Label className="fw-bold ms-5 me-2 mb-0">अर्ज क्रमांक :</Form.Label>
                                        <div className="border border-dark px-3 py-1 bg-light" style={{ minWidth: '150px', height: '35px' }}></div>
                                    </div>

                                    <div className="mt-3">
                                        <p className="fw-bold mb-1">प्रती,</p>
                                        <p className="fw-bold mb-1">मा. ना. एकनाथजी शिंदे साहेब</p>
                                        <p className="fw-bold mb-0">शिवसेना मुख्यनेते तथा उपमुख्यमंत्री (महाराष्ट्र राज्य)</p>
                                    </div>

                                    <div className="mt-3 text-start fw-bold">
                                        <p className=" fw-bold mb-0">
                                            सप्रेम जय महाराष्ट्र ,<br />
                                            आगामी पिंपरी चिंचवड सार्वत्रिक निवडणूक २०२५-२६ ची निवडणूक लढविण्यास मी इच्छुक असून मी पक्षाशी एकनिष्ठपणे पक्षाचे काम करेल, पक्षाची ध्येय धोरणे माझ्यावर बंधनकारक राहतील तरी निवडणुकीमध्ये मी शिवसेना पक्षाचा संभाव्य उमेदवार म्हणून निवडणूक लढण्यास तयार आहे. तरी आपण माझ्या उमेदवारीचा विचार करून मला निवडणूक लढण्याची संधी मिळावी ही आपणास नम्र विनंती, माझी वैयक्तिक माहिती खालील प्रमाणे.
                                        </p>
                                    </div>
                                </div>

                                <div className="photo-section text-center ms-3 d-flex flex-column align-items-center">
                                    {/* Photo Preview Box */}
                                    <div className="photo-box mb-2">
                                        {photoPreview ? (
                                            <img src={photoPreview} alt="Preview" className="photo-img" />
                                        ) : (
                                            <span className="photo-text">फोटो</span>
                                        )}
                                    </div>
                                    {/* Explicit File Input below the box */}
                                    <Form.Control
                                        type="file"
                                        name="photo"
                                        accept="image/*"
                                        onChange={handleChange}
                                        size="sm"
                                        style={{ width: '140px', fontSize: '0.75rem' }}
                                    />
                                </div>
                            </div>

                            {/* --- RED HEADER: PERSONAL INFO --- */}
                            <div className="text-center mb-3 position-relative header-wrapper">
                                <div className="header-icon left-icon">
                                    <img src={Sidelog} alt="logo" />
                                </div>
                                <div className="section-header-red">
                                    <h3 className="mb-0 text-white fw-bold">माझी वैयक्तिक माहिती</h3>
                                </div>
                                <div className="header-icon right-icon">
                                    <img src={Sidelog} alt="logo" />
                                </div>
                            </div>

                            {/* --- ROW 1: Ward Boxes --- */}
                            <div className="d-flex align-items-center flex-wrap gap-2 mb-3">
                                <span className="fw-bold">प्रभाग क्र.</span>
                                <Form.Select name="wardNo" value={formData.wardNo} onChange={handleChange} className="box-input" style={{ width: '120px', marginTop: "20px" }}>
                                    <option value="">निवडा</option>
                                    {subsection.map((item) => (
                                        <option key={item.id} value={item.name}>{item.name}</option>
                                    ))}
                                </Form.Select>

                                <span className="fw-bold ms-2">जागा अ/ब/क/ड</span>
                                <Form.Select name="seatCode" value={formData.seatCode} onChange={handleChange} className="box-input" style={{ width: '100px', marginTop: "20px" }}>
                                    <option value="">निवडा</option>
                                    <option value="1">अ</option>
                                    <option value="2">ब</option>
                                    <option value="3">क</option>
                                    <option value="4">ड</option>
                                </Form.Select>

                                <span className="fw-bold ms-2">भाग क्र.</span>
                                <Form.Control type="partNo" name="partNo" value={formData.partNo} onChange={handleChange} className="box-input" style={{ width: '80px' }} />

                                <span className="fw-bold ms-2">मतदारयादीतील अ.क्र.</span>
                                <Form.Control type="voterSrNo" name="voterSrNo" value={formData.voterSrNo} onChange={handleChange} className="box-input" style={{ width: '80px' }} />
                            </div>

                            {/* --- Active Member --- */}
                            <div className="d-flex align-items-center mb-3">
                                <span className="fw-bold text-nowrap me-2">शिवसेना पक्षाचे क्रियाशील / सक्रिय सभासद आहेत का असल्यास सभासद क्रमांक</span>
                                <Form.Control
                                    type="membershipNo"
                                    name="membershipNo"
                                    value={formData.membershipNo}
                                    onChange={handleChange}
                                    className="box-input"
                                />
                            </div>

                            {/* --- Full Line Inputs --- */}
                            <div className="d-flex" style={{ width: "100%" }}>
                                {/* FULL NAME - 70% */}
                                <div style={{ width: "100%" }} className="me-3 d-flex mb-2">
                                    <div className="d-flex align-items-end" style={{ height: "40px" }}>
                                        <span className="fw-bold text-nowrap me-2 d-flex align-items-end">पूर्ण नाव</span>
                                    </div>
                                    <div style={{ flexGrow: 1, height: "40px" }} className="d-flex align-items-end">
                                        <Form.Control
                                            type="fullName"
                                            name="fullName"
                                            value={formData.fullName}
                                            placeholder="पूर्ण नाव लिहा"
                                            onChange={handleChange}
                                            className="line-input border-0 border-bottom border-dark rounded-0 px-1 w-100"
                                        />
                                    </div>
                                </div>
                                {/* EMAIL - 30% */}
                                <div style={{ width: "30%" }} className="d-flex">
                                    <div className="d-flex align-items-end" style={{ height: "40px" }}>
                                        <span className="fw-bold text-nowrap me-2 d-flex align-items-end">ई-मेल</span>
                                    </div>
                                    <div style={{ flexGrow: 1, height: "40px" }} className="d-flex align-items-end">
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            className="line-input border-0 border-bottom border-dark rounded-0 px-1 w-100"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="mb-2 d-flex align-items-end">
                                <span className="fw-bold text-nowrap me-2">संपूर्ण पत्ता</span>
                                <Form.Control size="sm" as="textarea" rows={1} name="address" value={formData.address} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" style={{ resize: 'none' }} />
                            </div>

                            <div className="mb-2 d-flex align-items-end">
                                <div className="d-flex align-items-end flex-grow-1 me-3">
                                    <span className="fw-bold text-nowrap me-2 mb-1">जात /पोटजात</span>
                                    <Form.Control
                                        type="caste"
                                        name="caste"
                                        value={formData.caste}
                                        onChange={handleChange}
                                        className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1"
                                    />
                                </div>
                                <div className="d-flex align-items-center" style={{ paddingBottom: "2px" }}>
                                    <span className="fw-bold text-nowrap me-2 mb-1">सोबत जात प्रमाणपत्राची प्रत जोडावी:</span>
                                    <Form.Control
                                        type="file"
                                        name="casteFile"
                                        accept="image/*,.pdf"
                                        onChange={handleChange}
                                        size="sm"
                                        style={{ width: '180px', height: '28px', fontSize: '0.75rem', padding: '0', lineHeight: '28px', margin: '0' }}
                                    />
                                </div>
                            </div>

                            <div className="mb-2 d-flex align-items-center flex-wrap">
                                <div className="d-flex align-items-end flex-grow-1 me-3 mb-2">
                                    <span className="fw-bold text-nowrap me-2">मोबाईल नंबर</span>
                                    <Form.Control type="mobile" name="mobile" value={formData.mobile}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            if (/^\d*$/.test(val)) {
                                                handleChange(e);
                                            }
                                        }}
                                        className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                                </div>
                            </div>

                            <div className="d-flex align-items-end mb-2 gap-3 flex-wrap">
                                <div className="d-flex align-items-end">
                                    <span className="fw-bold text-nowrap me-2">जन्मतारीख :</span>
                                    <Form.Control type="date" name="dob" value={formData.dob} onChange={handleChange} className="line-input" style={{ width: '140px' }} />
                                </div>
                                <div className="d-flex align-items-end">
                                    <span className="fw-bold text-nowrap me-2">वय</span>
                                    <Form.Control type="age" name="age" value={formData.age} onChange={handleChange} className="line-input" style={{ width: '60px' }} />
                                </div>
                                <div className="d-flex align-items-end flex-grow-1">
                                    <span className="fw-bold text-nowrap me-2">शिक्षण</span>
                                    <Form.Control type="education" name="education" value={formData.education} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                                </div>
                            </div>

                            <div className="d-flex align-items-end mb-2 gap-3">
                                <div className="d-flex align-items-end flex-grow-1">
                                    <span className="fw-bold text-nowrap me-2">व्यवसाय :</span>
                                    <Form.Control type="occupation" name="occupation" value={formData.occupation} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                                </div>
                                <div className="d-flex align-items-end flex-grow-1">
                                    <span className="fw-bold text-nowrap me-2">वार्षिक उत्पन्न रु.</span>
                                    <Form.Control type="income" name="income" value={formData.income} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                                </div>
                            </div>

                            <div className="d-flex align-items-end mb-2 gap-2 flex-wrap">
                                <div className="d-flex align-items-end">
                                    <span className="fw-bold text-nowrap me-2">शिवसेनेत किती वर्षे आहात ?</span>
                                    <Form.Control type="yearsInParty" name="yearsInParty" value={formData.yearsInParty} onChange={handleChange} className="line-input border-0 border-bottom border-dark rounded-0 px-1" style={{ width: '80px' }} />
                                </div>
                                <div className="d-flex align-items-end flex-grow-1">
                                    <span className="fw-bold text-nowrap me-2">शिवसेना पद</span>
                                    <Form.Control type="partyPost" name="partyPost" value={formData.partyPost} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                                </div>
                                <div className="d-flex align-items-end flex-grow-1">
                                    <span className="fw-bold text-nowrap me-2">शासकीय पद:</span>
                                    <Form.Control type="govPost" name="govPost" value={formData.govPost} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                                </div>
                            </div>

                            <div className="mb-2 d-flex align-items-end">
                                <span className="fw-bold text-nowrap me-2">यापूर्वी कोणत्या पदावर काम केले</span>
                                <Form.Control type="prevPost" name="prevPost" value={formData.prevPost} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                            </div>

                            <div className="mb-2 d-flex align-items-end">
                                <span className="fw-bold text-nowrap me-2">इतर सामाजिक कार्य</span>
                                <Form.Control type="socialWork" name="socialWork" value={formData.socialWork} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                            </div>

                            <div className="mb-4 d-flex align-items-end">
                                <span className="fw-bold text-nowrap me-2">खर्चाची तयारी</span>
                                <Form.Control type="privateInfo" name="privateInfo" value={formData.privateInfo} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                            </div>

                            <br />

                            {/* --- RED HEADER: WARD DETAILS --- */}
                            <div className="text-center mb-3">
                                <div className="section-header-red d-inline-block px-5 py-2">
                                    <h3 className="mb-0 text-white fw-bold">प्रभागातील सविस्तर माहिती</h3>
                                </div>
                            </div>

                            <div className="text-center text-danger fw-bold mb-3">प्रभागातील आरक्षणे</div>

                            <Row className="mb-3 g-3">
                                {/* Row 1: A & B */}
                                <Col md={6}>
                                    <div className="d-flex align-items-end">
                                        <span className="fw-bold me-2 text-nowrap">१) अ</span>
                                        <Form.Control type="resA" name="resA" value={formData.resA} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="d-flex align-items-end">
                                        <span className="fw-bold me-2 text-nowrap">२) ब</span>
                                        <Form.Control type="resB" name="resB" value={formData.resB} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                                    </div>
                                </Col>
                                {/* Row 2: C & D */}
                                <Col md={6}>
                                    <div className="d-flex align-items-end">
                                        <span className="fw-bold me-2 text-nowrap">३) क</span>
                                        <Form.Control type="resC" name="resC" value={formData.resC} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="d-flex align-items-end">
                                        <span className="fw-bold me-2 text-nowrap">४) ड</span>
                                        <Form.Control type="resD" name="resD" value={formData.resD} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                                    </div>
                                </Col>
                            </Row>

                            <div className="text-center text-danger fw-bold mb-3 mt-4">२०१७ प्रभागांमधील माजी नगरसेवक</div>

                            <Row className="mb-3 g-3">
                                <Col md={6}>
                                    <div className="d-flex align-items-end">
                                        <span className="fw-bold me-2 text-nowrap">१) अ)</span>
                                        <span className="fw-bold text-nowrap">पक्ष</span>
                                        <Form.Control type="statusA" name="statusA" value={formData.statusA} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="d-flex align-items-end">
                                        <span className="fw-bold me-2 text-nowrap">२) ब)</span>
                                        <span className="fw-bold text-nowrap">पक्ष</span>
                                        <Form.Control type="statusB" name="statusB" value={formData.statusB} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="d-flex align-items-end">
                                        <span className="fw-bold me-2 text-nowrap">३) क)</span>
                                        <span className="fw-bold text-nowrap">पक्ष</span>
                                        <Form.Control type="statusC" name="statusC" value={formData.statusC} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                                    </div>
                                </Col>
                            </Row>

                            <div className="d-flex align-items-end mb-2 gap-3 mt-4">
                                <div className="d-flex align-items-end flex-grow-1">
                                    <span className="fw-bold text-nowrap me-2">प्रभागांमधील मतदारांची संख्या</span>
                                    <Form.Control type="number" name="voterCount" value={formData.voterCount} onChange={handleChange} className="line-input w-100" />
                                </div>
                                <div className="d-flex align-items-end flex-grow-1">
                                    <span className="fw-bold text-nowrap me-2">प्रभागाची लोकसंख्या</span>
                                    <Form.Control type="number" name="population" value={formData.population} onChange={handleChange} className="line-input w-100" />
                                </div>
                            </div>

                            <div className="mb-2 d-flex align-items-end">
                                <span className="fw-bold text-nowrap me-2">प्रभागातील सर्व यादी भाग क्रमांक</span>
                                <Form.Control type="boothParts" name="boothParts" value={formData.boothParts} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                            </div>

                            <div className="mb-2 d-flex align-items-end">
                                <span className="fw-bold text-nowrap me-2">प्रभागातील विशेष माहिती</span>
                                <Form.Control type="specialInfo" name="specialInfo" value={formData.specialInfo} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                            </div>

                            <div className="mb-4 d-flex align-items-end">
                                <span className="fw-bold text-nowrap me-2">यापूर्वी निवडणूक लढवली असल्यास मिळालेले मतदान</span>
                                <Form.Control type="prevVotes" name="prevVotes" value={formData.prevVotes} onChange={handleChange} className="line-input w-100 border-0 border-bottom border-dark rounded-0 px-1" />
                            </div>
                            <br />

                            {/* --- DECLARATION --- */}
                            <div className="text-center mb-3">
                                <div className="section-header-red d-inline-block px-5 py-2">
                                    <h4 className="mb-0 text-white fw-bold">प्रतिज्ञापत्र / हमीपत्र</h4>
                                </div>
                            </div>

                            <div className="mt-3 text-start fw-bold">
                                <div className="d-flex align-items-end mb-1">
                                    <span className="fw-bold me-2 text-nowrap">मी. श्री / सौ.</span>
                                    <Form.Control type="decName" name="decName" value={formData.decName || formData.fullName} onChange={handleChange} placeholder="नाव लिहा" className="line-input flex-grow-1 border-0 border-bottom border-dark rounded-0 px-1" />
                                </div>
                                <br />
                                <p className="mb-0 fw-bold" style={{ lineHeight: '1.6' }}>
                                    सत्य प्रतिज्ञेवर लिहून देतो की, वरील माहिती सत्य व बरोबर आहे मा.ना.एकनाथजी शिंदे साहेब शिवसेना मुख्य नेते व उपमुख्यमंत्री (महाराष्ट्र राज्य) आणि स्थानिक लोकप्रतिनिधी व वरिष्ठ पदाधिकाऱ्यांच्या आदेशाचे वेळोवेळी पालन करून संघटना वाढविण्यासाठी मी प्रयत्न करेल आपल्या पक्षाने दिलेले आदेश आमच्यासाठी बंधनकारक असतील. हा अर्ज म्हणजे उमेदवारी नाही हे मला माहित आहे. मी नागरिकांसाठी केलेले समाजकार्य व राजकीय कामाचा अनुभव असल्यामुळे उमेदवारी दिल्यास मी निवडून येण्यासाठी जास्तीत जास्त प्रयत्न करीन. माझ्या ऐवजी दुसऱ्या इच्छुक उमेदवारास उमेदवारी दिल्यास पक्षादेश मानून त्या उमेदवाराच्या विजयासाठी प्रामाणिकपणे मनापासून प्रयत्न करीन. तसेच कोणत्याही प्रकारची बंडखोरी व गैरवर्तन करणार नाही. मी उमेदवारी अर्ज फक्त शिवसेनेकडेच केला असून अन्य पक्ष/संघटना आघाडीकडे अर्ज केलेला नाही. त्यामुळे माझ्या अर्जाचा सहानुभूतीपूर्वक विचार करावा ही नम्र विनंती धन्यवाद.
                                </p>
                            </div>

                            <div className="mt-3 text-start fw-bold">
                                <span className="fw-bold">आपला / आपली नम्र</span>
                            </div>

                            <div className="d-flex justify-content-between align-items-end mt-4">
                                <div className="w-50 mb-3">
                                    <div className="d-flex align-items-end mb-3">
                                        <span className="fw-bold me-2 text-nowrap">दिनांक :</span>
                                        <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} className="line-input w-50 border-0 border-bottom border-dark rounded-0 px-1" />
                                    </div>
                                    <div className="d-flex align-items-end">
                                        <span className="fw-bold me-2 text-nowrap">ठिकाण :</span>
                                        <Form.Control type="place" name="place" value={formData.place} onChange={handleChange} className="line-input w-50 border-0 border-bottom border-dark rounded-0 px-1" />
                                    </div>
                                </div>

                                <div className="w-50 text-end">
                                    <div className="d-flex align-items-center justify-content-end mb-3">
                                        <span className="fw-bold me-2 text-nowrap">  इतर कागदपत्र: (Upload) :</span>
                                        <Form.Control
                                            type="file"
                                            name="otherDocumentPdf"
                                            accept="image/*,.pdf"
                                            onChange={handleChange}
                                            size="sm"
                                            style={{ width: '180px', height: '28px', fontSize: '0.75rem', padding: '0', lineHeight: '28px', margin: '0' }}
                                        />
                                    </div>
                                    <div className="d-flex align-items-end justify-content-end">
                                        <span className="fw-bold me-2 text-nowrap">नाव: श्री/सौ.</span>
                                        <Form.Control type="decName" name="decName" value={formData.decName || formData.fullName} readOnly className="line-input w-50 border-0 border-bottom border-dark rounded-0 px-1" />
                                    </div>
                                </div>
                            </div>

                            <div className="text-center mt-5 no-print">
                                <Button type="submit" variant="danger" size="lg">अर्ज सबमिट करा</Button>
                            </div>

                        </Form>
                    </div>
                </div>
            </div >
            <div className="text-end small pe-3">मागे पहा</div>
        </Container >
    );
};

export default CandidateFormOrange;